export enum BaseConfirmPromptSizeEnum {
  SM = "sm",
  MD = "md",
}

export enum BaseConfirmPromptTypeEnum {
  DEFAULT = "default",
  INVITE = "invite",
}
